import { RootState } from 'store/rootReducer';

export const toastSelector = (state: RootState) => state.toast;
